<e-dialog [open]="open()" (openChange)="onOpenChange($event)" [title]="t('humanDesign.iching.export.import.title')" size="md">
  <ng-template>
    <div class="iching-import" data-test-id="iching-import-dialog">
      <p class="iching-import__intro">{{ t('humanDesign.iching.export.import.intro') }}</p>

      <div class="iching-import__info">
        <h5 class="iching-import__info-title">
          <i class="fas fa-circle-info" aria-hidden="true"></i>
          {{ t('humanDesign.iching.export.import.howTitle') }}
        </h5>
        <ul class="iching-import__list">
          <li>{{ t('humanDesign.iching.export.import.howOwn') }}</li>
          <li>{{ t('humanDesign.iching.export.import.howDuplicates') }}</li>
          <li>{{ t('humanDesign.iching.export.import.howChart') }}</li>
          <li>{{ t('humanDesign.iching.export.import.howHexagrams') }}</li>
        </ul>
      </div>

      @if (state() === 'done') {
        @if (result(); as r) {
          <div class="iching-import__result" role="status" data-test-id="iching-import-result">
            <p>{{ t('humanDesign.iching.export.import.result', { imported: r.imported ?? 0, skipped: r.skippedDuplicates ?? 0 }) }}</p>
            @if ((r.linked ?? 0) + (r.unlinked ?? 0) > 0) {
              <p>{{ t('humanDesign.iching.export.import.resultLinked', { linked: r.linked ?? 0, unlinked: r.unlinked ?? 0 }) }}</p>
            }
            @if ((r.invalid ?? 0) > 0) {
              <p class="iching-import__warning">{{ t('humanDesign.iching.export.import.resultInvalid', { count: r.invalid }) }}</p>
            }
          </div>
        }
        <div class="iching-import__actions">
          <button eBtn color="primary-75" type="button" (click)="close()" data-test-id="iching-import-close">
            {{ t('humanDesign.iching.export.import.close') }}
          </button>
        </div>
      } @else {
        @if (errorKey(); as key) {
          <p class="iching-import__error" role="alert" data-test-id="iching-import-error">{{ t('humanDesign.iching.export.import.errors.' + key) }}</p>
        }
        @if (parsed(); as p) {
          <div class="iching-import__found" data-test-id="iching-import-found">
            <p class="iching-import__file"><i class="fas fa-file-code" aria-hidden="true"></i> {{ fileName() }}</p>
            <p>{{ foundText(p) }}</p>
            @if (p.invalid > 0) {
              <p class="iching-import__warning">{{ t('humanDesign.iching.export.import.skippedLocal', { count: p.invalid }) }}</p>
            }
          </div>
        }
        <div class="iching-import__actions">
          <input #fileInput type="file" accept=".json,application/json" hidden (change)="onFileChosen($event)" data-test-id="iching-import-file" />
          <button eBtn type="button" icon="folder-open" [disabled]="state() === 'busy'" (click)="fileInput.click()" data-test-id="iching-import-choose">
            {{ parsed() ? t('humanDesign.iching.export.import.chooseOther') : t('humanDesign.iching.export.import.choose') }}
          </button>
          @if (parsed()) {
            <button
              eBtn
              color="primary-75"
              type="button"
              icon="file-import"
              [loading]="state() === 'busy'"
              [disabled]="state() === 'busy'"
              (click)="start()"
              data-test-id="iching-import-start"
            >
              {{ t('humanDesign.iching.export.import.start') }}
            </button>
          }
        </div>
      }
    </div>
  </ng-template>
</e-dialog>
